export { PharmacyHolidaysModal } from './pharmacy-holidays-modal';
